import { FC, useState, useEffect } from "react";
import { TrajetType, PecType } from "data/types";
import EvenementBtns2 from "components/EvenementBtns2";
import EvenementBtns3 from "components/EvenementBtns3";
import { useTranslation } from 'react-i18next';

export interface CardTrajetProps {
  className?: string;
  author: TrajetType;
  index: string;
  listePecPlanificateur?: PecType[];
  onBlocNotesClick: (typeEvenement: string, idEvenement: number) => void;
  onConfirmClick: (typeEvenement: string, idEvenement: number) => void;
  selected?: boolean;
  isMap?: boolean;
  onLocalisationClick?: (type: String) => void;
  onRechercheClick?: (typeEvenement: string, idEvenement: number) => void;
  symbole_monnaie: string;
  numDroit: number;
}

const CardTrajet: FC<CardTrajetProps> = ({
  className = "",
  author,
  index,
  listePecPlanificateur,
  onBlocNotesClick,
  onConfirmClick,
  selected,
  isMap,
  onLocalisationClick,
  onRechercheClick,
  symbole_monnaie,
  numDroit
}) => {
  const { t } = useTranslation();

  const { displayName, libelle2, prix, paiement, type, debut, fin, compagnie, ref, location, moment, duree, distance, lat, longi, lat2, longi2, simplifie } = author;
  const [lienVisible, setLienVisible] = useState("");
  const [lienItineraire, setLienItineraire] = useState("");
  const [showOptions, setShowOptions] = useState<boolean>(false);
  const [isSimplifie, setIsSimplifie] = useState(simplifie);

  useEffect(() => {
    //gestion lien lien_modifie si createur ou visiteur et etat=R pour créateur géré par l'api
    if(author.lien !== undefined && author.lien !== "" && numDroit ===1)
    {
      setLienVisible(author.lien);
    }
    else if(author.lien !== undefined && author.lien !== "" && author.etat_lien ==="V")
    {
      setLienVisible(author.lien);
    } 
    else if(author.lien !== undefined && author.lien !== "" && author.etat_lien === "M" && author.lien_modifie !== undefined && author.lien_modifie !== "")
    {
      setLienVisible(author.lien_modifie);
    }

    if(author.lat !== "" && author.longi !== "" && author.lat2 !== "" && author.longi2 !== "")
    {
      setLienItineraire("https://www.google.com/maps/dir/"+author.lat+","+author.longi+"/"+author.lat2+","+author.longi2+"/");
    }
    else if(author.lat !== "" && author.longi !== "")
    {
      setLienItineraire("https://www.google.com/maps/dir//"+author.lat+","+author.longi+"/");
    }
    else if(author.lat2 !== "" && author.longi2 !== "")
    {
      setLienItineraire("https://www.google.com/maps/dir//"+author.lat2+","+author.longi2+"/");
    }

  }, []);

  const afficheOptions = () => {
    setShowOptions(true);
  }

  const cacheOptions = () => {
    setShowOptions(false);
  }

   const hasTransportDetails =
  distance !== "" ||
  duree !== "" ||
  ref !== "" ||
  compagnie !== "";

  const hasDureeDistance = duree !== "" || distance !== "";

  const hasCompagnieRef = compagnie !== "" || ref !== "";

  const isLocation = location === "O";
const isPriseEnCharge = isLocation && moment === "P";
const isRestitution = isLocation && moment === "R";
const typeIcon = type && type !== "" ? `la-${type}` : "la-route";
const hasDepart = displayName !== "" || debut !== "";
const hasArrivee = libelle2 !== "" || fin !== "";

const showTimeline = location !== "O" && ((!isSimplifie && (hasDepart || hasArrivee)) || (isSimplifie && (debut || fin || duree || distance || ref || compagnie)));
const showStartPoint = location !== "O" && hasDepart;
const showEndPoint = location !== "O" && hasArrivee;

const hasBlocTransport =
  hasTransportDetails ||
  ((isPriseEnCharge || isRestitution) && type !== "");

  const needsDepartArriveeSpacing =
  showStartPoint &&
  showEndPoint &&
  !hasTransportDetails &&
  location !== "O";
  
  const arrivalSpacingClass = !showStartPoint && showEndPoint
  ? "pt-4"
  : needsDepartArriveeSpacing
  ? "pt-7"
  : "pt-1";

  return (
    <>
  {isSimplifie ? (
  <div
    onMouseOver={afficheOptions}
    onMouseLeave={cacheOptions}
    className={`
      relative
      curseurPointeur
      w-full
      ${className}
    `}
  >
    {/* OPTIONS MODE SIMPLIFIÉ */}
    {(author.bloc !== "" || author.document !== "" || lienVisible || lienItineraire) && (
      <EvenementBtns3
        optionsVisibles={!isMap ? showOptions : false}
        onRechercheClick={onRechercheClick}
        onBlocNotesClick={author.bloc !== "" ? onBlocNotesClick : undefined}
        onConfirmClick={author.document !== "" ? onConfirmClick : undefined}
        lienVisible={lienVisible}
        lienItineraire={lienItineraire}
        index={index || ""}
      />
    )}

    {/* CONTENU SIMPLIFIÉ MAP < LG : TIMELINE HORIZONTALE */}
{isMap && (
  <div className="lg:hidden w-full text-left">
    {showTimeline && (
      <div className="mb-2 px-1">
        <div className="relative flex items-center justify-between min-h-[28px]">
          
          {/* Ligne horizontale */}
          {(showStartPoint || showEndPoint) && (
            <span
  className="
    absolute
    left-[34px]
    right-[34px]
    top-1/2
    h-[1px]
    -translate-y-1/2

    bg-[repeating-linear-gradient(to_right,#d4d4d4_0px,#d4d4d4_4px,transparent_4px,transparent_8px)]
    dark:bg-[repeating-linear-gradient(to_right,#404040_0px,#404040_4px,transparent_4px,transparent_8px)]
  "
/>
          )}

          {/* Départ */}
          <div className="relative z-10 flex items-center gap-1 min-w-0  pr-2">
                        {debut !== "" && (
              <span className="text-xxs font-semibold text-neutral-500 dark:text-neutral-400 whitespace-nowrap">
                {debut}
              </span>
            )}
            {showStartPoint && (
              <span
                className="
                  block
                  flex-none

                  w-[8px]
                  h-[8px]
                  min-w-[8px]
                  min-h-[8px]

                  rounded-full

                  border-2
                  border-green-500

                "
              />
            )}

          </div>

          {/* Arrivée */}
          <div className="relative z-10 flex items-center gap-1 min-w-0  pl-2">

            {showEndPoint && (
              <span
                className="
                  block
                  flex-none

                  w-[8px]
                  h-[8px]
                  min-w-[8px]
                  min-h-[8px]

                  rounded-full

                  border-2
                  border-green-500
                "
              />
            )}
                        {fin !== "" && (
              <span className="text-xxs font-semibold text-neutral-500 dark:text-neutral-400 whitespace-nowrap">
                {fin}
              </span>
            )}
          </div>
        </div>
      </div>
    )}

    {/* BLOC TRANSPORT SOUS LA TIMELINE HORIZONTALE */}
    {hasBlocTransport && (
      <div
        className="
          my-2

          rounded-2xl
          bg-neutral-50
          dark:bg-neutral-800/70

          border
          border-neutral-100
          dark:border-neutral-700

          px-0
          py-1
        "
      >
        <div
          className="
            flex
            items-center
            gap-1

            text-[10px]
            text-neutral-600
            dark:text-neutral-300
          "
        >
          {/* Compagnie + ref */}
          {hasCompagnieRef && (
            <div
              className="
                flex
                items-center
                gap-1
                min-w-0
                flex-1
              "
            >
              <div
                className={`
                  min-w-0
                  w-full
                  leading-tight
                  ml-1

                  ${hasDureeDistance || ((isPriseEnCharge || isRestitution) && type !== "") ? "text-right" : "text-center"}
                `}
              >
                {compagnie !== "" && (
                  <div className="text-xxs font-semibold text-neutral-900 dark:text-white truncate">
                    {compagnie}
                  </div>
                )}

                {ref !== "" && (
                  <div className="text-xxs text-neutral-500 dark:text-neutral-400 truncate">
                    {ref}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Séparateur */}
          {hasCompagnieRef && (((isPriseEnCharge || isRestitution) && type !== "") || hasDureeDistance) && (
            <div className="h-8 w-px bg-neutral-200 dark:bg-neutral-700 flex-shrink-0" />
          )}

          {/* Icône location OU durée + distance */}
          {(isPriseEnCharge || isRestitution) && type !== "" ? (
            <div
              className={`
                flex
                items-center
                justify-center

                ${hasCompagnieRef ? "flex-shrink-0" : "flex-1"}

                mr-1
              `}
            >
              <div
                className="
                  w-8
                  h-8
                  flex
                  items-center
                  justify-center
                  text-purple-600
                "
                title={isPriseEnCharge ? "Prise en charge" : "Restitution"}
              >
                <i className={`las ${typeIcon} text-lg`} />
              </div>
            </div>
          ) : (
            hasDureeDistance && (
              <div
                className={`
                  flex
                  flex-col
                  justify-center
                  leading-tight
                  mr-1

                  ${
                    hasCompagnieRef
                      ? "items-start flex-shrink-0 text-left"
                      : "items-center flex-1 text-center"
                  }
                `}
              >
                {duree !== "" && (
                  <div
                    className={`
                      flex
                      items-center
                      gap-0

                      ${hasCompagnieRef ? "" : "justify-center w-full"}
                    `}
                  >
                    <i className="las la-clock text-xs text-neutral-500 mr-0.5" />
                    <span className="no-slider-margin whitespace-nowrap text-xxs">
                      {duree}
                    </span>
                  </div>
                )}

                {distance !== "" && (
                  <div
                    className={`
                      flex
                      items-center
                      gap-0

                      ${hasCompagnieRef ? "" : "justify-center w-full"}
                    `}
                    data-tooltip-id="myTooltip"
                    data-tooltip-content="Estimation à vol d'oiseau ou selon le mode de transport si la durée est affichée"
                    data-tooltip-place="bottom"
                  >
                    <i className="las la-ruler-combined text-xs text-neutral-500 mr-0.5" />
                    <span className="no-slider-margin whitespace-nowrap text-xxs">
                      {distance} km
                    </span>
                  </div>
                )}
              </div>
            )
          )}
        </div>
      </div>
    )}
  </div>
)}

    {/* CONTENU SIMPLIFIÉ AVEC TIMELINE */}
    <div
  className={`
    ${isMap ? "hidden lg:grid" : "grid"}
    grid-cols-[16px_minmax(0,1fr)]
    gap-x-0
    text-left
  `}
>

      {/* POINT DÉPART */}
      {showTimeline && (
        <div className="relative flex justify-center pt-1">

          {showStartPoint && (
            <span
              className="
                relative
                z-1
                block
                flex-none

                w-[8px]
                h-[8px]
                min-w-[8px]
                min-h-[8px]

                rounded-full

                border-2
                border-green-500

                bg-white
                dark:bg-neutral-900
              "
            />
          )}

          {(showEndPoint || hasBlocTransport) && (
            <span
              className={`
                absolute
                w-[1px]

                ${showStartPoint ? "top-[16px]" : "top-0"}
                -bottom-3

                bg-[repeating-linear-gradient(to_bottom,#d4d4d4_0px,#d4d4d4_4px,transparent_4px,transparent_8px)]
                dark:bg-[repeating-linear-gradient(to_bottom,#404040_0px,#404040_4px,transparent_4px,transparent_8px)]
              `}
            />
          )}
        </div>
      )}

      {/* HEURE DÉPART UNIQUEMENT */}
      <div className={`${location === "O" ? "col-span-2" : ""} min-w-0`}>
        {debut !== "" && (
          <div className="grid grid-cols-[22px_minmax(0,1fr)] gap-3 items-start">
            <div className="relative top-[3px] text-xxs font-semibold text-neutral-500 leading-snug">
              {debut}
            </div>
            <div />
          </div>
        )}
      </div>

      {/* BLOC TRANSPORT SIMPLIFIÉ */}
      {hasBlocTransport && (
        <>
          <div className="relative flex justify-center">
            {showTimeline && (
              <span
  className={`
    absolute
    w-[1px]

    ${showStartPoint ? "top-0" : "-top-3"}
    -bottom-3

    bg-[repeating-linear-gradient(to_bottom,#d4d4d4_0px,#d4d4d4_4px,transparent_4px,transparent_8px)]
    dark:bg-[repeating-linear-gradient(to_bottom,#404040_0px,#404040_4px,transparent_4px,transparent_8px)]
  `}
/>
            )}
          </div>

          <div className={`${location === "O" ? "col-span-2" : ""} min-w-0`}>
            <div
              className="
                my-3

                rounded-2xl
                bg-neutral-50
                dark:bg-neutral-800/70

                border
                border-neutral-100
                dark:border-neutral-700

                px-0
                py-1
              "
            >
              <div
                className="
                  flex
                  items-center
                  gap-1

                  text-[10px]
                  text-neutral-600
                  dark:text-neutral-300
                "
              >
                {/* Compagnie + ref */}
                {hasCompagnieRef && (
                  <div
                    className="
                      flex
                      items-center
                      gap-1
                      min-w-0
                      flex-1
                    "
                  >
                    <div
                      className={`
                        min-w-0
                        w-full
                        leading-tight
                        ml-1

                        ${hasDureeDistance || ((isPriseEnCharge || isRestitution) && type !== "") ? "text-right" : "text-center"}
                      `}
                    >
                      {compagnie !== "" && (
                        <div className="text-xxs font-semibold text-neutral-900 dark:text-white truncate">
                          {compagnie}
                        </div>
                      )}

                      {ref !== "" && (
                        <div className="text-xxs text-neutral-500 dark:text-neutral-400 truncate">
                          {ref}
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* Séparateur */}
                {hasCompagnieRef && (((isPriseEnCharge || isRestitution) && type !== "") || hasDureeDistance) && (
                  <div className="h-8 w-px bg-neutral-200 dark:bg-neutral-700 flex-shrink-0" />
                )}

                {/* Icône location OU durée + distance */}
                {(isPriseEnCharge || isRestitution) && type !== "" ? (
                  <div
                    className={`
                      flex
                      items-center
                      justify-center

                      ${hasCompagnieRef ? "flex-shrink-0" : "flex-1"}

                      mr-1
                    `}
                  >
                    <div
                      className="
                        w-8
                        h-8
                        flex
                        items-center
                        justify-center
                        text-purple-600
                      "
                      title={isPriseEnCharge ? "Prise en charge" : "Restitution"}
                    >
                      <i className={`las ${typeIcon} text-lg`} />
                    </div>
                  </div>
                ) : (
                  hasDureeDistance && (
                    <div
                      className={`
                        flex
                        flex-col
                        justify-center
                        leading-tight
                        mr-1

                        ${
                          hasCompagnieRef
                            ? "items-start flex-shrink-0 text-left"
                            : "items-center flex-1 text-center"
                        }
                      `}
                    >
                      {duree !== "" && (
                        <div
                          className={`
                            flex
                            items-center
                            gap-0

                            ${hasCompagnieRef ? "" : "justify-center w-full"}
                          `}
                        >
                          <i className="las la-clock text-xs text-neutral-500 mr-0.5" />
                          <span className="no-slider-margin whitespace-nowrap text-xxs">
                            {duree}
                          </span>
                        </div>
                      )}

                      {distance !== "" && (
                        <div
                          className={`
                            flex
                            items-center
                            gap-0

                            ${hasCompagnieRef ? "" : "justify-center w-full"}
                          `}
                          data-tooltip-id="myTooltip"
                          data-tooltip-content="Estimation à vol d'oiseau ou selon le mode de transport si la durée est affichée"
                          data-tooltip-place="bottom"
                        >
                          <i className="las la-ruler-combined text-xs text-neutral-500 mr-0.5" />
                          <span className="no-slider-margin whitespace-nowrap text-xxs">
                            {distance} km
                          </span>
                        </div>
                      )}
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </>
      )}

 {/* POINT ARRIVÉE */}
{showTimeline && (
  <div
    className={`
      relative
      flex
      justify-center

      ${arrivalSpacingClass}
    `}
  >
          <span
            className={`
              absolute
              w-[1px]

              ${
  !showStartPoint && showEndPoint
    ? "top-0 h-4 bg-[repeating-linear-gradient(to_bottom,#d4d4d4_0px,#d4d4d4_2px,transparent_2px,transparent_6px)] dark:bg-[repeating-linear-gradient(to_bottom,#404040_0px,#404040_2px,transparent_2px,transparent_6px)]"
    : showEndPoint
    ? needsDepartArriveeSpacing
      ? "-top-0 bottom-[8px] bg-[repeating-linear-gradient(to_bottom,#d4d4d4_0px,#d4d4d4_4px,transparent_4px,transparent_8px)] dark:bg-[repeating-linear-gradient(to_bottom,#404040_0px,#404040_4px,transparent_4px,transparent_8px)]"
      : "-top-3 top-[4px] bg-[repeating-linear-gradient(to_bottom,#d4d4d4_0px,#d4d4d4_4px,transparent_4px,transparent_8px)] dark:bg-[repeating-linear-gradient(to_bottom,#404040_0px,#404040_4px,transparent_4px,transparent_8px)]"
    : "-top-3 bottom-0 bg-[repeating-linear-gradient(to_bottom,#d4d4d4_0px,#d4d4d4_4px,transparent_4px,transparent_8px)] dark:bg-[repeating-linear-gradient(to_bottom,#404040_0px,#404040_4px,transparent_4px,transparent_8px)]"
}
            `}
          />

          {showEndPoint && (
            <span
              className="
                relative
                z-1
                block
                flex-none

                w-[8px]
                h-[8px]
                min-w-[8px]
                min-h-[8px]

                rounded-full

                border-2
                border-green-500

                bg-white
                dark:bg-neutral-900
              "
            />
          )}
        </div>
      )}

      {/* HEURE ARRIVÉE UNIQUEMENT */}
     <div
  className={`
    ${location === "O" ? "col-span-2" : ""}
    min-w-0

  ${
  !showStartPoint && showEndPoint
    ? "pt-4"
    : needsDepartArriveeSpacing
    ? "pt-7"
    : ""
}
  `}
>
        {fin !== "" && (
          <div className="grid grid-cols-[22px_minmax(0,1fr)] gap-3 items-start">
            <div className="relative top-[3px] text-xxs font-semibold text-neutral-500 dark:text-neutral-400 leading-snug">
              {fin}
            </div>
            <div />
          </div>
        )}
      </div>
    </div>
  </div>
) : (

    <div
 className={`
  ${selected ? "selectedCard" : ""}

  nc-CardTrajet
  group
  relative
  w-full

  rounded-[30px]
  overflow-visible

  bg-[linear-gradient(145deg,rgba(255,255,255,0.98)_0%,rgba(255,255,255,0.94)_55%,rgba(248,250,252,0.96)_100%)]
dark:bg-[linear-gradient(145deg,rgba(15,23,42,0.98)_0%,rgba(17,24,39,0.96)_55%,rgba(10,15,28,0.98)_100%)]


  border
  border-white/80
  dark:border-white/10

  shadow-[0_14px_32px_rgba(15,23,42,0.10),inset_0_1px_0_rgba(255,255,255,0.95)]
  dark:shadow-[0_14px_32px_rgba(0,0,0,0.34),inset_0_1px_0_rgba(255,255,255,0.06)]
  hover:shadow-[0_18px_40px_rgba(15,23,42,0.14),inset_0_1px_0_rgba(255,255,255,0.95)]
  dark:hover:shadow-[0_18px_40px_rgba(0,0,0,0.42),inset_0_1px_0_rgba(255,255,255,0.08)]

  px-4
  py-4

  transition-all
  duration-300
  ease-out
  hover:-translate-y-[2px]

  ${showOptions ? "z-[9999]" : "z-1"}

  ${className}
`}
  data-nc-id="CardTrajet"
  onMouseOver={afficheOptions}
  onMouseLeave={cacheOptions}
>
{/* couche visuelle de la card, clipsée aux coins */}
<div
  className="
    pointer-events-none
    absolute
    inset-0
    rounded-[30px]
    overflow-hidden
  "
>
  {/* effet bulle 3D : lumière douce */}
  <div
    className="
      absolute
      inset-0
      rounded-[30px]
      bg-[radial-gradient(circle_at_20%_0%,rgba(255,255,255,0.95)_0%,transparent_38%),radial-gradient(circle_at_100%_100%,rgba(241,245,249,0.75)_0%,transparent_42%)]
      dark:bg-[radial-gradient(circle_at_20%_0%,rgba(255,255,255,0.08)_0%,transparent_34%),radial-gradient(circle_at_100%_100%,rgba(255,74,82,0.08)_0%,transparent_42%)]
  
    "
  />

  {/* bordure intérieure glossy */}
  <div
    className="
      absolute
      inset-[1px]
      rounded-[29px]
      border
      border-white/80
          dark:border-white/10
    "
  />

  {/* ombre interne très subtile en bas */}
  <div
    className="
      absolute
      inset-0
      rounded-[30px]
      shadow-[inset_0_-10px_22px_rgba(15,23,42,0.035)]
      dark:shadow-[inset_0_-10px_24px_rgba(0,0,0,0.24)]
    "
  />
</div>

{/* OPTIONS */}
{(author.bloc !== "" || author.document !== "" || lienVisible || lienItineraire) && (
  <EvenementBtns2
  onCloseOptions={cacheOptions}
    optionsVisibles={false}
    onRechercheClick={onRechercheClick}
    onBlocNotesClick={author.bloc !== "" ? onBlocNotesClick : undefined}
    onConfirmClick={author.document !== "" ? onConfirmClick : undefined}
    lienVisible={lienVisible}
    lienItineraire={lienItineraire}
    index={index || ""}
  />
)}

{/* CONTENU TRAJET */}
<div className="relative z-10 grid grid-cols-[16px_minmax(0,1fr)] gap-x-0 text-left">
{/* POINT DÉPART */}
{/* POINT DÉPART */}
{showTimeline && (
  <div className="relative z-10 flex justify-center pt-1">

    {/* Point haut seulement si départ affiché */}
    {showStartPoint && (
      <span
        className="
          relative
          z-1
          block
          flex-none

          w-[8px]
          h-[8px]
          min-w-[8px]
          min-h-[8px]

          rounded-full

          border-2
          border-green-500

          bg-white
          dark:bg-neutral-900
        "
      />
    )}


{/* Trait depuis le point de départ */}
{showStartPoint && (
  <span
    className={`
      absolute
      top-[14px]
      w-[1px]

      ${
        showEndPoint || hasTransportDetails
          ? needsDepartArriveeSpacing
            ? "-bottom-7"
            : "-bottom-3"
          : "bottom-0"
      }

      bg-[repeating-linear-gradient(to_bottom,#d4d4d4_0px,#d4d4d4_4px,transparent_4px,transparent_8px)]
      dark:bg-[repeating-linear-gradient(to_bottom,#404040_0px,#404040_4px,transparent_4px,transparent_8px)]
    `}
  />
)}
  </div>
)}

  {/* DÉPART */}
  <div className={`${location === "O" ? "col-span-2" : ""} min-w-0`}>
    {(debut !== "" || displayName !== "") && (
   <div
  className={`
    ${debut === "" ? "block" : "grid grid-cols-[22px_minmax(0,1fr)] gap-3 items-start"}
  `}
>
  {debut !== "" && (
    <div className="relative top-[3px] text-xxs font-semibold text-neutral-500 leading-snug">
      {debut}
    </div>
  )}

  <div className="min-w-0">
          {displayName !== "" && (
            <h2
              className={`${location === "O" && debut === "" ? "text-center" : "text-left"} text-xs
                font-semibold
                text-neutral-900
                dark:text-white
                leading-snug
                break-words`}
            >
              <span
                aria-hidden="true"
                className="
                  no-slider-margin
                  float-right
                  w-4
                  h-3
                "
              />

              {displayName}

              {isMap && displayName !== "" && (lat === "" || longi === "") && (
                <>
                  {" "}
                  <i
                    className="las la-location-arrow text-rose-500"
                    data-tooltip-id="myTooltip"
                    data-tooltip-content={t("coordonneesGPSAbsentes")}
                    data-tooltip-place="top"
                    onClick={
                      numDroit === 1 || numDroit === 0
                        ? () => alert("Pour placer ce lieu, veuillez passer en mode modification.")
                        : undefined
                    }
                  />
                </>
              )}

              {isMap && displayName !== "" && lat !== "" && longi !== "" && (
                <>
                  {" "}
                  <i
                    className="curseurPointeur las la-location-arrow text-green-500"
                    data-tooltip-id="myTooltip"
                    data-tooltip-content={t("cliquezCarte")}
                    data-tooltip-place="top"
                    onClick={() => onLocalisationClick && onLocalisationClick("depart")}
                  />
                </>
              )}
            </h2>
          )}
        </div>
      </div>
    )}
  </div>

  {/* LIGNE TRANSPORT : le trait prend automatiquement la hauteur du bloc */}
  {hasTransportDetails && (
    <>
 <div className="relative flex justify-center">
  {showTimeline && (
    <span
      className="
        absolute
        -top-3
        -bottom-3
        w-[1px]

        bg-[repeating-linear-gradient(to_bottom,#d4d4d4_0px,#d4d4d4_4px,transparent_4px,transparent_8px)]
        dark:bg-[repeating-linear-gradient(to_bottom,#404040_0px,#404040_4px,transparent_4px,transparent_8px)]
      "
    />
  )}
</div>

      <div className={`${location === "O" ? "col-span-2" : ""} min-w-0`}>
        {/* BLOC TRANSPORT : compagnie + durée + distance */}
        <div
          className="
            my-3

            rounded-2xl
            bg-neutral-50
            dark:bg-neutral-800/70

            border
            border-neutral-100
            dark:border-neutral-700

            px-0
            py-1
          "
        >
          <div
            className="
              flex
              items-center
              gap-1

              text-[10px]
              text-neutral-600
              dark:text-neutral-300
            "
          >
            {/* Compagnie + ref */}
            {(compagnie !== "" || ref !== "") && (
              <div
                className="
                  flex
                  items-center
                  gap-1
                  min-w-0
                  flex-1
                "
              >
                <div
                  className={`
                    min-w-0
                    w-full
                    leading-tight
                    ml-1

                    ${hasDureeDistance ? "text-right" : "text-center"}
                  `}
                >
                  {compagnie !== "" && (
                    <div className="text-xxs font-semibold text-neutral-900 dark:text-white truncate">
                      {compagnie}
                    </div>
                  )}

                  {ref !== "" && (
                    <div className="text-xxs text-neutral-500 dark:text-neutral-400 truncate">
                      {ref}
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Séparateur */}
     {hasCompagnieRef && (((isPriseEnCharge || isRestitution) && type && type !== '') || hasDureeDistance) && (
              <div className="h-8 w-px bg-neutral-200 dark:bg-neutral-700 flex-shrink-0" />
            )}

            {/* Icône location OU durée + distance */}
{(isPriseEnCharge || isRestitution) && type && type !== '' ? (
  <div
    className={`
      flex
      items-center
      justify-center

      ${hasCompagnieRef ? "flex-shrink-0" : "flex-1"}

      mr-1
    `}
  >
    <div
      className="
        w-8
        h-8
        flex
        items-center
        justify-center
       text-purple-600"

      title={isPriseEnCharge ? "Prise en charge" : "Restitution"}
    >
      <i className={`las ${typeIcon} text-lg`} />
    </div>
  </div>
) : (
  (duree !== "" || distance !== "") && (
    <div
      className={`
        flex
        flex-col
        justify-center
        leading-tight
        mr-1

        ${
          hasCompagnieRef
            ? "items-start flex-shrink-0 text-left"
            : "items-center flex-1 text-center"
        }
      `}
    >
      {duree !== "" && (
        <div
          className={`
            flex
            items-center
            gap-0

            ${hasCompagnieRef ? "" : "justify-center w-full"}
          `}
        >
          <i className="las la-clock text-xs text-neutral-500 mr-0.5" />
          <span className="no-slider-margin whitespace-nowrap text-xxs">
            {duree}
          </span>
        </div>
      )}

      {distance !== "" && (
        <div
          className={`
            flex
            items-center
            gap-0

            ${hasCompagnieRef ? "" : "justify-center w-full"}
          `}
          data-tooltip-id="myTooltip"
          data-tooltip-content="Estimation à vol d'oiseau ou selon le mode de transport si la durée est affichée"
          data-tooltip-place="bottom"
        >
          <i className="las la-ruler-combined text-xs text-neutral-500 mr-0.5" />
          <span className="no-slider-margin whitespace-nowrap text-xxs">
            {distance} km
          </span>
        </div>
      )}
    </div>
  )
)}
          </div>
        </div>
      </div>
    </>
  )}

{/* POINT ARRIVÉE */}
{showTimeline && (
  <div
    className={`
      relative
      flex
      justify-center

      ${
        !showStartPoint && showEndPoint
          ? "pt-4"
          : needsDepartArriveeSpacing
          ? "pt-7"
          : "pt-1"
      }
    `}
  >
    {showEndPoint && (
      <span
        className={`
          absolute
          w-[1px]

          ${
            !showStartPoint
              ? "top-0 h-4"
              : needsDepartArriveeSpacing
              ? "top-[4px] "
              : isMap
              ? "-top-3 bottom-[10px]"
              : "-top-3 top-[4px]"
          }

          bg-[repeating-linear-gradient(to_bottom,#d4d4d4_0px,#d4d4d4_4px,transparent_4px,transparent_8px)]
          dark:bg-[repeating-linear-gradient(to_bottom,#404040_0px,#404040_4px,transparent_4px,transparent_8px)]
        `}
      />
    )}

    {showEndPoint && (
      <span
        className="
          relative
          top-[3px]
          z-[1]
          block
          h-[8px]
          w-[8px]
          min-h-[8px]
          min-w-[8px]
          flex-none
          rounded-full
          border-2
          border-green-500
          bg-white
          dark:bg-neutral-900
        "
      />
    )}
  </div>
)}

{/* ARRIVÉE */}
<div
  className={`
    ${location === "O" ? "col-span-2" : ""}
    min-w-0

    ${
      !showStartPoint && showEndPoint
        ? "pt-4"
        : needsDepartArriveeSpacing
        ? "pt-7"
        : ""
    }
  `}
>
  {(fin !== "" || libelle2 !== "") && (
    <div
  className={`
    ${fin === "" ? "block" : "grid grid-cols-[22px_minmax(0,1fr)] gap-3 items-start"}
  `}
>
  {fin !== "" && (
    <div className="relative top-[3px] text-xxs font-semibold text-neutral-500 dark:text-neutral-400 leading-snug">
      {fin}
    </div>
  )}

  <div className="min-w-0">
          {libelle2 !== "" && (
            <h2
              className={`${location === "O" && fin === "" ? "text-center" : "text-left"} text-xs
                font-semibold
                text-neutral-900
                dark:text-white
                leading-snug
                break-words`}
            >
              {libelle2}

              {isMap && libelle2 !== "" && (lat2 === "" || longi2 === "") && (
                <>
                  {" "}
                  <i
                    className="las la-location-arrow text-rose-500"
                    data-tooltip-id="myTooltip"
                    data-tooltip-content={t("coordonneesGPSAbsentes")}
                    data-tooltip-place="top"
                    onClick={
                      numDroit === 1 || numDroit === 0
                        ? () => alert("Pour placer ce lieu, veuillez passer en mode modification.")
                        : undefined
                    }
                  />
                </>
              )}

              {isMap && libelle2 !== "" && lat2 !== "" && longi2 !== "" && (
                <>
                  {" "}
                  <i
                    className="curseurPointeur las la-location-arrow text-green-500"
                    data-tooltip-id="myTooltip"
                    data-tooltip-content={t("cliquezCarte")}
                    data-tooltip-place="top"
                    onClick={() => onLocalisationClick && onLocalisationClick("arrivee")}
                  />                </>
              )}
            </h2>
          )}
        </div>
      </div>
    )}
  </div>
</div>
     {!isMap && prix !== "" && Number(prix) !== 0 ? (
  <div
    className={`
      ${
      isLocation
        ? "mt-1"
        : "mt-4"}
      pt-3

      border-t
      border-neutral-100
      dark:border-neutral-800

      flex
      items-center
      justify-between

      text-xs
      text-neutral-900
      dark:text-white
    `}
  >
    <span>
      {prix} {symbole_monnaie}
    </span>

    <span >
      {paiement === "paye" && (
        <>
          Payé <i
                        className="
                        
                          las
                          la-check
                          text-xs
                          leading-none
                          text-emerald-500
                          drop-shadow-[0_1px_1px_rgba(16,185,129,0.35)]
                        "
                      />
        </>
      )}
    </span>
  </div>
) : null}

    {listePecPlanificateur && location === "O" && index && moment === "R" && listePecPlanificateur.map((pec, pecIndex) => (
      <div className="text-xxs relative z-10 " key={`pec-${pecIndex}`}>
        {pec.rattachement === index.split('-')[1] && (
          <span>
          {pec.type_transport !== "" && <i className={`text-purple-500 text-sm las la-${pec.type_transport}`}>&nbsp;</i>}
          Début : {pec.date_journee.split(" ")[1]}
          {pec.debut !== "" && ` à ${pec.debut}`}</span>
        )}
      </div>
    ))}
    </div>
  )}
  </>
  );
};

export default CardTrajet;
